import React from "react";
import { DialogType, EntityDialog } from "./types";
import { InformationRequest } from "../../../domain/InformationRequest";
import { ActivityType } from "../../../domain/ActivityType";
import { UpdatedDialog } from "./dialogs/UpdatedDialog";
import { SendMessageDialog } from "./dialogs/SendMessageDialog";

type RenderDialogProps = {
  focussedEntity: EntityDialog | null;
  onClose: () => void;
  informationRequest: InformationRequest;
  resourceId: string;
};

export const RenderDialog: React.FC<RenderDialogProps> = ({
  focussedEntity,
  onClose,
  informationRequest,
  resourceId,
}) => {
  if (!focussedEntity) {
    return null;
  }

  const { dialogType } = focussedEntity;

  if (dialogType === DialogType.SendMessage) {
    return (
      <SendMessageDialog
        onClose={onClose}
        resourceId={resourceId}
        informationRequest={informationRequest}
      />
    );
  } else {
    const activity = focussedEntity.focussedActivity!;
    switch (activity.activityType) {
      case ActivityType.InformationRequestUpdated:
        return <UpdatedDialog activity={activity} onClose={onClose} />;
      default:
        return null;
    }
  }
};
